const MIC_GATE_WORKLET_MODULE_URL = new URL('./mic-gate-processor.js', import.meta.url)
const MIC_GATE_WORKLET_PROCESSOR_NAME = 'mic-gate-processor'

/**
 * Builds the noise gate that sits on the microphone leg of the share-tab mix.
 *
 * The gate itself lives in an AudioWorklet so it can decide per sample on the
 * audio thread; see `mic-gate-processor.js` for what it does and why it is not a
 * GainNode driven from a timer.
 *
 * @param audioContext AudioContext driving the mix; the worklet module is
 *   registered on it lazily (safe to call more than once per context).
 * @returns A node to insert between the microphone source and the mix bus.
 */
export async function createMicGate(audioContext: AudioContext): Promise<AudioWorkletNode> {
  await audioContext.audioWorklet.addModule(MIC_GATE_WORKLET_MODULE_URL)
  return new AudioWorkletNode(audioContext, MIC_GATE_WORKLET_PROCESSOR_NAME)
}
